/** Lecture du chemin `/PAYS/JETON` — F-CNF-07, F-CNF-08. */
export interface CheminPartage {
  readonly pays: string;
  readonly jeton: string;
}

const MOTIF_CHEMIN = /^\/([A-Z]{2})\/([A-Za-z0-9_-]+)\/?$/;

export function analyserChemin(pathname: string): CheminPartage | null {
  const trouve = MOTIF_CHEMIN.exec(pathname);
  if (trouve === null) return null;
  const [, pays, jeton] = trouve;
  if (pays === undefined || jeton === undefined) return null;
  return { pays, jeton };
}
